import { subscriptionStatusFilterAtom } from 'src/atoms/filters/sim';
import { SubscriptionStatusSelect } from 'src/common/components/SubscriptionStatus/SubscriptionStatusSelect';

export const SimProfilesSuscriptionStatusInput = () => {
  return <SubscriptionStatusSelect subscriptionStatusesFilterAtom={subscriptionStatusFilterAtom} />;
};
